var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardi3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    fill: "#FFF0E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7917 34.1667H51.2235C56.387 34.1667 58.9688 34.1667 60.7618 35.4299C61.2755 35.7919 61.7316 36.2211 62.1161 36.7046C63.4583 38.3921 63.4583 40.822 63.4583 45.6818V49.7121C63.4583 54.4038 63.4583 56.7497 62.7158 58.6232C61.5222 61.6353 58.9979 64.0111 55.7976 65.1345C53.8069 65.8334 51.3145 65.8334 46.3295 65.8334C43.481 65.8334 42.0567 65.8334 40.9192 65.434C39.0905 64.7921 37.648 63.4344 36.9659 61.7133C36.5417 60.6427 36.5417 59.3022 36.5417 56.6212V50",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4583 50C63.4583 52.9148 61.0954 55.2778 58.1806 55.2778C57.1264 55.2778 55.8836 55.0931 54.8587 55.3677C53.948 55.6117 53.2367 56.323 52.9927 57.2337C52.7181 58.2586 52.9028 59.5014 52.9028 60.5556C52.9028 63.4704 50.5398 65.8333 47.625 65.8333",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 42.875C38.9033 43.6757 40.9746 46.8334 42.0833 46.8334M46.0417 42.875C45.2634 43.6757 43.192 46.8334 42.0833 46.8334M42.0833 46.8334V34.1667",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardi3);
export default __webpack_public_path__ + "static/media/cardi3.32020bfdb4786f9427bcc77ade29284f.svg";
export { ForwardRef as ReactComponent };